import {toast} from 'react-toastify';
import { api } from '@/api';
import { TTaskRequest } from '@/types';
import {NAME_STATUS_API_ORDER} from '../../../Applications/consts';

export  const createResponseTask = (id:number, data: TTaskRequest) => {
    const response = api.task.responseTask(id,{
        ...data
    });
    toast.promise(
        response,
        {
            pending: NAME_STATUS_API_ORDER.RESPONSE_TASK.PENDING,
            error: {
                render(res: Record<string, any>) {
                    const {status,data} = res.data.response;
                    if (status === 500 || status === 501 || status === 502 || status === 503 ) {
                        toast.error(NAME_STATUS_API_ORDER.RESPONSE_TASK.ERROR_500 + status)
                    }
                    if(data){
                        // eslint-disable-next-line guard-for-in,no-restricted-syntax
                        for(let key in data){
                            toast.error(data[key][0])
                        }
                    }
                    return NAME_STATUS_API_ORDER.RESPONSE_TASK.ERROR
                }
            }
        });
    return response;
}